// src/components/EquipmentSVG.js
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.2 },
  },
};

const gearVariants = {
  hidden: { scale: 0.5, opacity: 0, rotate: -90 },
  visible: {
    scale: 1,
    opacity: 1,
    rotate: 0,
    transition: { duration: 1, ease: "easeOut" },
  },
};

// 기어 모양 Path 데이터
const gearPath = "M49.999,16.526c-18.453,0-33.474,15.021-33.474,33.474c0,18.451,15.021,33.473,33.474,33.473c18.452,0,33.474-15.022,33.474-33.473C83.473,31.547,68.451,16.526,49.999,16.526z M49.999,76.473c-14.607,0-26.474-11.867-26.474-26.473c0-14.606,11.867-26.474,26.474-26.474c14.606,0,26.474,11.867,26.474,26.474C76.473,64.606,64.604,76.473,49.999,76.473z";

export default function EquipmentSVG({ gradientId }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      variants={svgVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.g variants={gearVariants} style={{ transformOrigin: 'center' }}>
        <path d={gearPath} fill={`url(#${gradientId})`} />
      </motion.g>
      <motion.g variants={gearVariants} style={{ transformOrigin: 'center' }} transform="scale(0.6) translate(65, 20)">
        <path d={gearPath} fill={`url(#${gradientId})`} fillOpacity={0.7} />
      </motion.g>
      <motion.g variants={gearVariants} style={{ transformOrigin: 'center' }} transform="scale(0.4) translate(-10, 130)">
        <path d={gearPath} fill={`url(#${gradientId})`} fillOpacity={0.5} />
      </motion.g>
    </motion.svg>
  );
}